const defaultState = {
    sortingLogic: {}
};

const storeInstitutionDataReducer = (state = defaultState, action) => {

    switch (action.type) {
        case 'SAVE_INSTITUTIONDATA_FULFILLED': {
            return {
                ...state,
                institutionData: action.payload
            };
        }
        default: {
            return state;
        }
    }
};

export default storeInstitutionDataReducer;


// WEBPACK FOOTER //
// ./src/reducers/VXC/storeInstitutionData.js